import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Utils } from '@app/shared/helpers/utils';
import { Observable } from 'rxjs';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IModelo } from '../model/modelo.model';

@Injectable()
export class ModeloService extends EntityService<IModelo> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'modelo',
      urlBackend: configService.backendURL
    });
  }

  /**
   * Pega peças disponiveis para um modelo e retorna eles paginados
   * @param modelo_id
   * @param pagination
   * @param include
   * @param where
   * @returns
   */
  pecasModelo(
    modelo_id: string,
    pagination: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    include: string[],
    domain_id: string,
    where?: string | { field: string; value: string }
  ) {
    var url = `${this.baseURL}/${modelo_id}/pecas_disponiveis`;
    var params = new HttpParams();

    if (pagination) {
      params = params
        .append('page', pagination.page)
        .append('page_size', pagination.page_size)
        .append('require_pagination', pagination.require_pagination);
    }

    if (include) params = params.append('include', include.join(','));

    if (domain_id) params = params.append('domain_id', domain_id);

    if (where) {
      if (typeof where === 'object' && Object.keys(where).length !== 0)
        params = params.append(`${where.field}`, where.value);
      else if (typeof where === 'string')
        params = params.append('peca_id', where);
    }

    return this.http.get<any>(url, {
      params: params,
      headers: this.getHeader()
    });
  }

  /**
   * Adiciona todas as materias primas dentro do modelo
   * @param modelo_id
   * @param body {conversao: number, type: ACABAMENTOS | ADICIONAIS | MATERIAS}
   * @returns
   */
  addAllMateriais(modelo_id: string, body): Observable<any> {
    const url = `${this.baseURL}/${modelo_id}/add_all_materias`;
    return this.http.put<any>(url, body, {
      headers: this.getHeader()
    });
  }

  /**
   * Função responsável por listar as etapas disponiveis por parte
   * @param url_material
   * @param modelo_id
   * @param pagination
   * @param include
   * @param domain_id
   * @param where
   * @returns
   */
  materiaisDisponiveis(
    modelo_id: string,
    pagination: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    include: string[],
    domain_id: string,
    categoria?: string,
    where?: any
  ) {
    var url = `${this.baseURL}/${modelo_id}/materias_disponiveis`;
    var params = new HttpParams();

    if (pagination) {
      params = params
        .append('page', pagination.page)
        .append('page_size', pagination.page_size)
        .append('require_pagination', pagination.require_pagination);
    }

    if (include) params = params.append('include', include.join(','));

    if (domain_id) where = { ...where, domain_id: domain_id };

    if (categoria) params = params.append('categoria.classificacao', categoria);

    if (where && typeof where === 'object' && Object.keys(where).length !== 0) {
      Object.keys(where).forEach(key => {
        params = params.append(`${key}`, where[key]);
      });
    }

    return this.http.get<any>(url, {
      params: params,
      headers: this.getHeader()
    });
  }

  addModeloMp(body: {
    materia_prima_id: string;
    classificacao: string;
    modelos: { modelo_id: string; conversao: string }[];
  }): Observable<any> {
    const url = `${this.baseURL}/add_materia`;
    return this.http.put<{
      materia_prima_id: string;
      classificacao: string;
      modelos_sucesso: {
        id: string;
        descricao: string;
      }[];
      modelos_falha: {
        id: string;
        descricao: string;
        error: string;
      }[];
    }>(url, body, {
      headers: this.getHeader()
    });
  }

  /**
   * Pega as categorias disponiveis para uma TPF com base no modelo e retorna eles paginados
   * @param where
   * @returns
   */
  categoriasDisponiveisTPF(where: any) {
    var url = `${this.baseURL}/categorias_disponiveis`;
    var params = new HttpParams();

    if (where) {
      if (typeof where === 'object' && Object.keys(where).length !== 0) {
        Object.keys(where).forEach(key => {
          if (where[key] !== null && where[key] !== undefined) {
            if (Array.isArray(where[key])) {
              params = params.append(`${key}`, where[key].join(','));
            } else {
              params = params.append(`${key}`, where[key]);
            }
          }
        });
      } else if (typeof where === 'string') url += `?&${where}`;
    }

    if (params.get('domain_id') === '') {
      params = params.set('domain_id', this.tokenService.getDomain().id);
    }

    return this.http.get<any>(url, {
      params: params,
      headers: this.getHeader()
    });
  }

  /**
   * Remove peças e/ou materiais do modelo e mediante essa ação valida o uso delas
   * em outras entidaes como o pedido
   * @param body
   */
  rmPecaOuMaterial(body: {
    modelo_id: string;
    tipo: string;
    tabela_ids: string[];
  }) {
    const url = `${this.baseURL}/${body.modelo_id}/remover_peca_ou_material`;
    return this.http.put(
      url,
      Utils.onlyAttributes(body, ['tipo', 'tabela_ids']),
      {
        headers: this.getHeader()
      }
    );
  }
}
